export const types = {
  'SET_SEARCH_TERM': 'SET_SEARCH_TERM',
};
